export const EXECUTION_TEMPLATES_CHANGED_EVENT = 'workops-execution-templates-changed';
export const KB_DOCUMENTS_CHANGED_EVENT = 'workops-kb-documents-changed';

export function emitExecutionTemplatesChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EXECUTION_TEMPLATES_CHANGED_EVENT));
  }
}

export function emitKbDocumentsChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(KB_DOCUMENTS_CHANGED_EVENT));
  }
}
